module.exports = __webpack_public_path__ + "e7751cf009878c1f81e78c28e393579b.png";